// extracted by mini-css-extract-plugin
export default {"bodyCover":"body_bodyCover__wCiRu","navCover":"body_navCover__mbaxG","navLeft":"body_navLeft__4Y72v","avatar_w":"body_avatar_w__RZdVH"};